import {
  Shape,
  ShapeGeometry,
  Mesh,
  MeshBasicMaterial,
  DoubleSide,
} from 'three';
import { materialConfig } from '@/functions/shaft3dModel';

/**
 * Diameter of the shaft
 * @param {number} diameter
 */
export function orientationHelper(diameter) {
  const elementSize = 3 * (diameter / 100); // A percentage of the shaft diameter
  const elementPosition = diameter / 2 + elementSize;

  const shape = new Shape();
  const x = 0;
  const y = 0;

  shape.moveTo(x - elementSize, y - elementSize);
  shape.lineTo(x, y + elementSize);
  shape.lineTo(x + elementSize, y - elementSize);
  shape.lineTo(x, y);

  const orientationMesh = new Mesh(
    new ShapeGeometry(shape),
    new MeshBasicMaterial({
      color: materialConfig.colours.eaimmsBlue,
      side: DoubleSide,
    })
  );

  orientationMesh.userData = { name: 'orientation' };
  orientationMesh.rotation.x = -1.55;
  orientationMesh.position.z = -elementPosition - elementSize;

  return orientationMesh;
}
